module.exports = __webpack_public_path__ + "media/toolkits/edit-light-06737c52.svg";